import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

import { Headline } from 'components/Headline';

const Header = styled.div`
  display: flex;
  align-items: center;

  height: 1.9rem;
  width: 14rem;
`;

const Label = styled.label`
  margin-right: 0.4rem;

  font-weight: 600;
  font-family: 'LFT Zeno', sans-serif;
  font-size: 1.2rem;

  white-space: nowrap;

  color: ${pickColor('black')};
`;

const ErrorMessage = styled(Headline)`
  margin-left: 1.2rem;

  white-space: nowrap;
`;

export { Header, Label, ErrorMessage };
